import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import Select from "react-dropdown-select";

import { useTheme, useLoyalty } from "../../../hooks";
import { NewBackButton } from "../../../components/svgs";
import { Button, StyledText } from "../../../components/common/basic";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

const ReferralPickup = () => {
  const regions = [
    { label: "Greater Accra Region", value: 0 },
    { label: "Ashanti Region", value: 1 },
    { label: "Western Region", value: 2 },
    { label: "Central Region", value: 3 },
    { label: "Eastern Region", value: 4 },
    { label: "Bono Region", value: 5 },
    { label: "Volta Region", value: 6 },
    { label: "Northern Region", value: 7 },
    { label: "Upper East Region", value: 8 },
    { label: "Upper West Region", value: 9 },
    { label: "Bono East Region", value: 10 },
    { label: "Western North Region", value: 11 },
    { label: "Oti Region", value: 12 },
    { label: "Ahafo Region", value: 13 },
  ];

  const cities = [
    [
      { label: "Achimota", value: 0 },
      { label: "37 Shell", value: 1 },
      { label: "Accra Central", value: 2 },
      { label: "Accra Mall", value: 3 },
      { label: "Akweteyman", value: 4 },
      { label: "Ashaiman", value: 5 },
      { label: "Circle", value: 6 },
      { label: "Dansoman", value: 7 },
      { label: "Darkuman", value: 8 },
      { label: "East Legon", value: 9 },
      { label: "Haatso", value: 10 },
      { label: "Junction Mall", value: 11 },
      { label: "Madina", value: 12 },
      { label: "McCarthy", value: 13 },
      { label: "Motorway Extension", value: 14 },
      { label: "NIA", value: 15 },
      { label: "Roman Ridge", value: 16 },
      { label: "Social Welfare", value: 17 },
      { label: "Spintex", value: 18 },
      { label: "Tema 1", value: 19 },
      { label: "Tema 25", value: 20 },
      { label: "Tema 6", value: 21 },
      { label: "Tesano", value: 22 },
      { label: "Teshie", value: 23 },
      { label: "Tudu", value: 24 },
      { label: "Osu", value: 25 },
      { label: "Ridge", value: 26 },
      { label: "Newtown", value: 27 },
      { label: "Dzorwulu", value: 28 },
      { label: "Ada", value: 29 },
    ],
    [
      { label: "Abuakwa", value: 0 },
      { label: "Adum", value: 1 },
      { label: "Atonsu", value: 2 },
      { label: "Ayigya", value: 3 },
      { label: "Bantama", value: 4 },
      { label: "Bibiani", value: 5 },
      { label: "Kejetia", value: 6 },
      { label: "KNUST", value: 7 },
      { label: "Konongo", value: 8 },
      { label: "Kumasi City Mall", value: 9 },
      { label: "Mampong", value: 10 },
      { label: "Nhyiaeso", value: 11 },
      { label: "Obuasi", value: 12 },
      { label: "Suame", value: 13 },
      { label: "Tafo", value: 14 },
    ],
    [
      { label: "Essiama", value: 0 },
      { label: "Takoradi Main", value: 1 },
      { label: "Takoradi Mall", value: 2 },
      { label: "Takoradi MC", value: 3 },
      { label: "Tarkwa", value: 4 },
      { label: "Bogoso", value: 5 },
    ],
    [
      { label: "Cape Coast Abura", value: 0 },
      { label: "Cape Coast", value: 1 },
      { label: "Kasoa", value: 2 },
      { label: "Winneba", value: 3 },
      { label: "Assin Fosu", value: 4 },
      { label: "Agona Swedru", value: 5 },
    ],
    [
      { label: "Atimpoku", value: 0 },
      { label: "Donkorkrom", value: 1 },
      { label: "Koforidua", value: 2 },
      { label: "New Abirem", value: 3 },
      { label: "Asamankese", value: 4 },
      { label: "Akim Oda", value: 5 },
      { label: "Suhum", value: 6 },
      { label: "Nkawkaw", value: 7 },
      { label: "Osino", value: 8 },
      { label: "Nsawam", value: 9 },
      { label: "Somanya", value: 10 },
    ],
    [
      { label: "Sunyani", value: 0 },
      { label: "Berekum", value: 1 },
      { label: "Dormaa", value: 2 },
    ],
    [
      { label: "Ho", value: 0 },
      { label: "Aflao", value: 1 },
      { label: "Hohoe", value: 2 },
    ],
    [
      { label: "Tamale Kaladan", value: 0 },
      { label: "Tamale", value: 1 },
      { label: "Bimbilla", value: 2 },
      { label: "Yendi", value: 3 },
    ],
    [
      { label: "Bolga", value: 0 },
      { label: "Bawku", value: 1 },
      { label: "Navrongo", value: 2 },
    ],
    [{ label: "Wa", value: 0 }],
    [
      { label: "Techiman", value: 0 },
      { label: "Atebubu", value: 1 },
      { label: "Kintampo", value: 2 },
    ],
    [
      { label: "Enchi", value: 0 },
      { label: "Sefwi Dwenase", value: 1 },
      { label: "Sefwi Juaboso", value: 2 },
    ],
    [
      { label: "Nkwanta", value: 0 },
      { label: "Kete-Krachi", value: 1 },
    ],
    [{ label: "Goaso", value: 0 }],
  ];

  const { themeContext, theme } = useTheme();

  const {
    saveCapturePickupLocation,
    wonItemForPickup,
    fullPickupLocation,
    setFullPickupLocation,
  } = useLoyalty();

  const history = useHistory();

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndSharePickup",
        firebase_screen_class: "CaptureAndSharePickup",
      })
    );
  }, []);

  const [seletedRegionIndex, setSeletedRegionIndex] = useState(0);
  const [selectedCity, setSelectedCity] = useState(
    cities[seletedRegionIndex].label
  );
  const [cityHasError, setCityHasError] = useState(false);
  const [regionHasError, setRegionHasError] = useState(false);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <>
      <Children>
        <Header>
          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <StyledText size={18} fontFamily={"medium"}>{`Pickup`}</StyledText>
        </Header>
        <StyledText
          size={12}
          style={{ marginBottom: 60, padding: 10 }}
        >{`Tell us where you want to receive your items.`}</StyledText>
        <PickupHolder>
          <InputHolder>
            <StyledText size={18}>{`Select MTN Office location`}</StyledText>
            <Select
              options={regions}
              values={[]}
              onChange={(value) => {
                if (value !== null) {
                  setSeletedRegionIndex(value[0].value);
                } else {
                  setSeletedRegionIndex(0);
                }
              }}
              placeholder='Please select an option'
              style={{
                borderRadius: 20,
                marginBottom: 20,
                width: 300,
                fontFamily: "MTNRegular",
              }}
            />
            <Select
              options={cities[seletedRegionIndex]}
              values={[]}
              onChange={(value) => setSelectedCity(value[0].label)}
              placeholder='Please select an option'
              style={{
                borderRadius: 20,
                marginBottom: 20,
                width: 300,
                fontFamily: "MTNRegular",
              }}
            />
          </InputHolder>
          <Button
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 10,
            }}
            color={background}
            onClick={() => {
              setFullPickupLocation(
                regions[seletedRegionIndex].label,
                selectedCity
              );

              saveCapturePickupLocation(
                {
                  ...wonItemForPickup,
                  pickup: `${regions[seletedRegionIndex].label} ${selectedCity}`,
                },
                history
              );
            }}
          >
            <StyledText style={{}}>{`Confirm`}</StyledText>
          </Button>
        </PickupHolder>
      </Children>
    </>
  );
};

const Children = styled.div`
  height: 700px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 60%;
  align-items: center;
`;

const PickupHolder = styled.div`
  margin-inline: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding-bottom: 20px;
`;

const InputHolder = styled.div``;
export default ReferralPickup;
